import Typography from '../../../../components/Typography';
import styles from './AboutSlide.module.scss';

function AboutSlide() {
  return (
    <div className={styles.container}>
      <Typography textType="h4" as="p">
        Once you're all set go to the Reviews page.
        <br />
        You can view all your week's reviews, generate replies to them at once,
        or even review your responses before they are sent off.
        <br />
        You can also access the Analytics page for relevant insights for your
        reviews.
      </Typography>
      <Typography className={styles.easy} textType="h4" as="p">
        It's that easy!
      </Typography>
      <img
        src={require('../../../../assets/reply-review.png')}
        alt="Reply being applied to reviews"
        className={styles.image}
        width="200"
      />
    </div>
  );
}

export default AboutSlide;
